import wx from 'weixin-js-sdk'
import { JS_API_LIST } from './enum'
const $wx = () => {
  const fn = {}

  /**
   * 载入 wx sdk 配置 并执行 ready 回调
   *
   * @returns Promise resolve null
   */
  fn.setConfig = ({
    debug = false,
    jsApiList = JS_API_LIST,
    appId,
    timestamp,
    nonceStr,
    signature
  }) => {
    return new Promise(resolve => {
      wx.config({
        debug,
        jsApiList,
        appId,
        timestamp,
        nonceStr,
        signature
      })
      wx.ready(() => {
        resolve()
      })
    })
  }

  fn.hideOptionMenu = () => {
    wx.hideOptionMenu()
  }
  /**
   * 分享给朋友”及“分享到QQ
   * @param {Object}
   * @return {Promsie}
   */
  fn.shareWithFriend = ({ title, desc, link, imgUrl } = {}) => {
    // const newPromise = new Promise(resolve => {
    //   wx.updateAppMessageShareData({
    //     title,
    //     desc,
    //     link,
    //     imgUrl,
    //     success: res => {
    //       resolve(res)
    //     }
    //   })
    // })
    const oldPromise = new Promise(resolve => {
      wx.onMenuShareAppMessage({
        title,
        desc,
        link,
        imgUrl,
        type: 'link',
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {
          resolve(res)
        }
      })
    })
    // return Promise.race([newPromise, oldPromise])
    return oldPromise
  }

  /**
   * 分享到朋友圈及分享到QQ空间
   * @param {Object}
   * @return {Promsie}
   */
  fn.shareTimeline = ({ title, link, imgUrl } = {}) => {
    // const newPromise = new Promise(resolve => {
    //   wx.updateTimelineShareData({
    //     title,
    //     link,
    //     imgUrl,
    //     success: res => {
    //       resolve(res)
    //     }
    //   })
    // })
    const oldPromise = new Promise(resolve => {
      wx.onMenuShareTimeline({
        title,
        link,
        imgUrl,
        success: res => {
          resolve(res)
        }
      })
    })
    // return Promise.race([newPromise, oldPromise])
    return oldPromise

  }

  /**
   * 选择图片
   * @param {Object}
   * @return {Promsie}
   * @return {array} Promise.resolve localIds
   * TODO: 使用时调试
   */
  fn.chooseImage = ({
    count = 9,
    sizeType = ['compressed'],
    sourceType = ['album', 'camera'],
    defaultCameraMode = 'normal'
  }) => {
    return new Promise((resolve, reject) => {
      wx.chooseImage({
        count,
        sizeType,
        sourceType,
        defaultCameraMode,
        success: res => {
          // this.localIds = res.localIds
          // this.updateBase64Data(this.localIds.shift())
          resolve(res.localIds)
        },
        fail: res => {
          reject(res)
        }
      })
    })
  }

  /**
   * 转换成 base64
   * TODO:
   */
  fn.updateBase64Data = (localId) => {
    wx.getLocalImgData({
      localId, // 图片的localID
      success: res => {
        let localData = res.localData
        let prefix = 'base64,'
        let index = localData.indexOf(prefix)
        let actData = localData
        // 我现在是设置参数，如果是展示的话则应该是添加头部data:image/jpeg;base64,
        if (index > -1) {
          actData = localData.substring(index + 7)
        }
        // base64Array是在data里定义的一个base64串数组
        this.base64Array.push(actData)

        if (this.localIds.length > 0) {
          this.updateBase64Data(this.loaclIds.shift())
        } else {
          // 执行处理
        }
      },
      fail: function(res) {
        alert('选择图片失败:' + res.errMsg)
      }
    })
  }
  /**
   * 上传图片
   * @param {String} localId
   * @return {Promsie}
   * @return {string} Promsie.resolve serverId 服务器端ID
   */
  fn.ploadImage = (localId) => {
    return new Promise(resolve => {
      wx.uploadImage({
        localId, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: res => {
          // this.serverId = res.serverId // 返回图片的服务器端ID
          resolve(res.serverId)
        }
      })
    })
  }
  /**
   * 下载图片接口
   * @param {Object}
   * @return {Promsie} localId 下载后的本地ID
   * @return {string} Promise.resolve localId 下载后的本地ID
   */
  fn.downloadImage = ({serverId = '', isShowProgressTips = 1}) => {
    return new Promise(resolve => {
      wx.downloadImage({
        serverId, // 需要下载的图片的服务器端ID，由uploadImage接口获得
        isShowProgressTips, // 默认为1，显示进度提示
        success: res => {
          // this.localId = res.localId // 返回图片下载后的本地ID
          resolve(res.localId)
        }
      })
    })
  }
  /**
   * 选择本地图片
   * 此接口仅在 iOS WKWebview 下提供，用于兼容 iOS WKWebview 不支持 localId 直接显示图片的问题
   * @param {Object}
   * @return {Promsie} localData base64数据
   */
  fn.getLocalImgData = ({localId}) => {
    return new Promise(resolve => {
      wx.getLocalImgData({
        localId, // 图片的localID
        success: res => {
          // this.localData = res.localData // localData是图片的base64数据，可以用img标签显示
          resolve(res.localData)
        }
      })
    })
  }

  /**
   * 添加微信支付监听
   * @param {Object} options
   * @param {string} timestamp
   * @param {string} nonceStr
   * @param {string} pkg
   * @param {string} signType
   * @param {string} paySign
   *
   */

  fn.payment = ({ timestamp, nonceStr, pkg, signType, paySign } = {}) => {
    return new Promise((resolve, reject) => {
      wx.chooseWXPay({
        timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr, // 支付签名随机串，不长于 32 位
        package: pkg, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign, // 支付签名
        success: res => {
        // 支付成功后的回调函数
          resolve(res)
        },
        fail: res => {
          reject(res)
        }
      })
    })
  }

  fn.getLocation = (type = 'wgs84') => {
    return new Promise((resolve, reject) => {
      wx.getLocation({
        type, // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          resolve({
            latitude: res.latitude, // 纬度，浮点数，范围为90 ~ -90
            longitude: res.longitude, // 经度，浮点数，范围为180 ~ -180。
            speed: res.speed, // 速度，以米/每秒计
            accuracy: res.accuracy // 位置精度
          })
        },
        fail: res => {
          reject(res)
        }
      })
    })
  }

  return fn
}
const wxPlugin = Vue => {
  Vue.prototype.$wx = $wx()
}
export default wxPlugin